"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepsContainer = void 0;

var _atoms = require("../../../atoms");

var _react = _interopRequireWildcard(require("react"));

var _StepController = require("../../../molecules/StepController");

var _LottieLoading = require("../../../molecules/LottieLoading");

var _ConfirmationModal = require("../../ConfirmationModal");

var _StepDescription = require("../StepDescription");

var _StepSpotlight = require("../StepSpotlight");

var _StepUpload = require("../StepUpload");

var _StepCancel = require("../StepCancel");

var _StepSport = require("../StepSport");

var _StepTrim = require("../StepTrim");

var _StepTags = require("../StepTags");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var StepsContainer = function StepsContainer(_ref) {
  var game = _ref.game,
      loading = _ref.loading,
      success = _ref.success,
      updates = _ref.updates,
      tagsType = _ref.tagsType,
      onUpdate = _ref.onUpdate,
      tempMoment = _ref.tempMoment,
      goToTraceId = _ref.goToTraceId,
      onCloseClick = _ref.onCloseClick,
      onRequestSave = _ref.onRequestSave,
      loadingMessage = _ref.loadingMessage,
      successMessage = _ref.successMessage,
      showConfirmation = _ref.showConfirmation,
      confirmButtonText = _ref.confirmButtonText,
      uploading = _ref.uploading,
      onUploadRequest = _ref.onUploadRequest,
      uploadingProgress = _ref.uploadingProgress,
      onCanPlayLocalVideo = _ref.onCanPlayLocalVideo,
      canPlayLocalVideo = _ref.canPlayLocalVideo,
      onRequestCancelUpload = _ref.onRequestCancelUpload,
      uploadedMoment = _ref.uploadedMoment;
  var defaultFirstStep = "upload";

  var _useState = (0, _react.useState)(defaultFirstStep),
      _useState2 = _slicedToArray(_useState, 2),
      step = _useState2[0],
      setStep = _useState2[1];

  var _useState3 = (0, _react.useState)("previous"),
      _useState4 = _slicedToArray(_useState3, 2),
      abortCancelAction = _useState4[0],
      setAbortCancelAction = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showConfirmCancel = _useState6[0],
      setShowConfirmCancel = _useState6[1];

  var _useState7 = (0, _react.useState)(defaultFirstStep),
      _useState8 = _slicedToArray(_useState7, 2),
      previousStep = _useState8[0],
      setPreviousStep = _useState8[1];

  var steps = ["upload", "trim", "spotlight", "sport", "tags", "description"];
  (0, _react.useEffect)(function () {
    if (loading) {
      setPreviousStep(step);
      setStep("loading");
    } else {
      setStep(previousStep);
      setPreviousStep("loading");
    }
  }, [loading]);
  (0, _react.useEffect)(function () {
    if (showConfirmCancel) {
      setPreviousStep(step);
      setStep("cancel");
    }
  }, [showConfirmCancel]);
  (0, _react.useEffect)(function () {
    if (success) {
      setStep("success");
    }
  }, [success]);

  var handleOnPreviousStep = function handleOnPreviousStep(newUpdates) {
    // If there are updates, then update
    onUpdate(newUpdates); // Navigate to previous step

    var currentIndex = steps.indexOf(step);
    var previousIndex = currentIndex - 1;

    if (previousIndex >= 0) {
      if (previousIndex === 0) {
        setAbortCancelAction("start_over");
        setShowConfirmCancel(true);
      } else {
        setStep(steps[previousIndex]);
      }
    }
  };

  var handleOnNextStep = function handleOnNextStep(newUpdates) {
    // Navigate to next step
    var currentIndex = steps.indexOf(step);
    var nextIndex = currentIndex + 1;

    if (nextIndex <= steps.length - 1) {
      onUpdate(newUpdates); // Not last step, go to next

      setStep(steps[nextIndex]);
    } else {
      // Last step, request a save
      if (typeof onRequestSave === "function") {
        onRequestSave(newUpdates);
      }
    }
  };

  var handleOnCloseClick = function handleOnCloseClick() {
    if (step === "upload" && !uploading && typeof onCloseClick === "function") {
      onCloseClick();
    } else {
      setAbortCancelAction("previous");
      setShowConfirmCancel(true);
    }
  };

  var handleOnAbortCancelClick = function handleOnAbortCancelClick() {
    setShowConfirmCancel(false);
    setStep(previousStep);
  };

  var handleOnConfirmCancelClick = function handleOnConfirmCancelClick() {
    if (abortCancelAction === "start_over") {
      onUpdate({
        didSelectFile: false
      });
      setStep("upload");
      setAbortCancelAction("previous");
      setShowConfirmCancel(false);

      if (typeof onRequestCancelUpload === "function") {
        onRequestCancelUpload();
      }
    } else if (typeof onCloseClick === "function") {
      onCloseClick();
    }
  };

  var getStepButtonTitle = function getStepButtonTitle(step) {
    var title;

    switch (step) {
      case "cancel":
        {
          title = "Cancel";
          break;
        }

      case "upload":
        {
          title = "Trim your video";
          break;
        }

      case "trim":
        {
          title = "Add a spotlight";
          break;
        }

      case "spotlight":
        {
          title = "Choose sport";
          break;
        }

      case "sport":
        {
          title = "Tag the moment";
          break;
        }

      case "tags":
        {
          title = "Add a description";
          break;
        }

      case "description":
        {
          title = confirmButtonText;
          break;
        }
    }

    return title;
  };

  var handleOnUploadRequest = function handleOnUploadRequest(file) {
    if (typeof onUploadRequest === "function") {
      onUploadRequest(file);
    }
  };

  var handleOnCanPlayLocalVideo = function handleOnCanPlayLocalVideo(result, file, url) {
    if (typeof onCanPlayLocalVideo === "function") {
      onCanPlayLocalVideo(result, file, url);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !showConfirmation && /*#__PURE__*/_react.default.createElement(_StepController.StepController, {
    step: step
  }, /*#__PURE__*/_react.default.createElement(_StepController.Step, {
    name: "loading"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Stack, {
    className: "upload-moment-preview-container",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    xs: _atoms.Stack.Type.Column,
    sm: _atoms.Stack.Type.Column,
    md: _atoms.Stack.Type.Column,
    lg: _atoms.Stack.Type.Column,
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_LottieLoading.LottieLoading, null), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Body,
    center: true,
    color: _atoms.Color.Grey2,
    content: loadingMessage,
    marginTop: "4",
    marginBottom: "6",
    width: "100%"
  })))), /*#__PURE__*/_react.default.createElement(_StepController.Step, {
    name: "success"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Stack, {
    className: "upload-moment-preview-container",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    xs: _atoms.Stack.Type.Column,
    sm: _atoms.Stack.Type.Column,
    md: _atoms.Stack.Type.Column,
    lg: _atoms.Stack.Type.Column
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, null, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    type: _atoms.Icon.Type.Check,
    color: _atoms.Color.Trace
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Body,
    color: _atoms.Color.Grey2,
    content: successMessage,
    marginTop: "4",
    marginBottom: "6"
  })))), /*#__PURE__*/_react.default.createElement(_StepCancel.StepCancel, {
    name: "cancel",
    tempMoment: tempMoment,
    updates: updates,
    uploading: uploading,
    uploadingProgress: uploadingProgress,
    buttonTitle: getStepButtonTitle("upload"),
    onNextStep: handleOnNextStep,
    showContentInMobile: true,
    canPlayLocalVideo: canPlayLocalVideo,
    onAbortCancelClick: handleOnAbortCancelClick,
    onConfirmCancelClick: handleOnConfirmCancelClick
  }), /*#__PURE__*/_react.default.createElement(_StepUpload.StepUpload, {
    name: "upload",
    tempMoment: tempMoment,
    updates: updates,
    uploading: uploading,
    uploadingProgress: uploadingProgress,
    buttonTitle: getStepButtonTitle("upload"),
    onNextStep: handleOnNextStep,
    showContentInMobile: true,
    onCloseClick: handleOnCloseClick,
    onUploadRequest: handleOnUploadRequest,
    onCanPlayLocalVideo: handleOnCanPlayLocalVideo,
    canPlayLocalVideo: canPlayLocalVideo
  }), /*#__PURE__*/_react.default.createElement(_StepTrim.StepTrim, {
    name: "trim",
    game: game,
    tempMoment: tempMoment,
    updates: updates,
    uploading: uploading,
    uploadingProgress: uploadingProgress,
    buttonTitle: getStepButtonTitle("trim"),
    showContentInMobile: true,
    onNextStep: handleOnNextStep,
    onCloseClick: handleOnCloseClick,
    onPreviousStep: handleOnPreviousStep,
    canPlayLocalVideo: canPlayLocalVideo
  }), /*#__PURE__*/_react.default.createElement(_StepSpotlight.StepSpotlight, {
    name: "spotlight",
    game: game,
    tempMoment: tempMoment,
    updates: updates,
    uploading: uploading,
    uploadingProgress: uploadingProgress,
    buttonTitle: getStepButtonTitle("spotlight"),
    showContentInMobile: true,
    onNextStep: handleOnNextStep,
    onCloseClick: handleOnCloseClick,
    onPreviousStep: handleOnPreviousStep,
    canPlayLocalVideo: canPlayLocalVideo,
    uploadedMoment: uploadedMoment
  }), /*#__PURE__*/_react.default.createElement(_StepSport.StepSport, {
    name: "sport",
    tempMoment: tempMoment,
    updates: updates,
    uploading: uploading,
    showPreviousButton: true,
    uploadingProgress: uploadingProgress,
    buttonTitle: getStepButtonTitle("sport"),
    onNextStep: handleOnNextStep,
    showContentInMobile: false,
    onCloseClick: handleOnCloseClick,
    onPreviousStep: handleOnPreviousStep,
    canPlayLocalVideo: canPlayLocalVideo
  }), /*#__PURE__*/_react.default.createElement(_StepTags.StepTags, {
    name: "tags",
    game: game,
    tempMoment: tempMoment,
    updates: updates,
    tagsType: tagsType,
    uploading: uploading,
    uploadingProgress: uploadingProgress,
    buttonTitle: getStepButtonTitle("tags"),
    showPreviousButton: true,
    showContentInMobile: false,
    onNextStep: handleOnNextStep,
    onCloseClick: handleOnCloseClick,
    onPreviousStep: handleOnPreviousStep,
    canPlayLocalVideo: canPlayLocalVideo
  }), /*#__PURE__*/_react.default.createElement(_StepDescription.StepDescription, {
    name: "description",
    tempMoment: tempMoment,
    updates: updates,
    uploading: uploading,
    uploadingProgress: uploadingProgress,
    buttonTitle: getStepButtonTitle("description"),
    showContentInMobile: false,
    onNextStep: handleOnNextStep,
    onCloseClick: handleOnCloseClick,
    onPreviousStep: handleOnPreviousStep,
    canPlayLocalVideo: canPlayLocalVideo
  })), showConfirmation && /*#__PURE__*/_react.default.createElement(_ConfirmationModal.ConfirmationModal, {
    onCloseClick: handleOnCloseClick,
    goToTraceId: goToTraceId
  }));
};

exports.StepsContainer = StepsContainer;
StepsContainer.defaultProps = {
  loadingMessage: "Personalizing your highlight...",
  allowEditTags: true,
  allowEditTime: true,
  allowEditTitle: true,
  allowEditSpotlight: true,
  allowConfirmation: false,
  confirmButtonText: "Create highlight",
  tagsType: "trace",
  game: null
};